// 用户管理
const UserManageRouter =    {
  path: 'userManage',
  name: 'UserManage',
  meta: {
    requiresAuth: false,
    leftMenu: true
  },
  component: () => import('@/views/Setting/userManage')
}
export default UserManageRouter
